import { useCallback, useState } from 'react';

export const useQuickEntry = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [activeEntity, setActiveEntity] = useState(null);
  const [notesTemplate, setNotesTemplate] = useState(null);

  const openDialog = useCallback(() => setIsDialogOpen(true), []);
  const closeDialog = useCallback(() => setIsDialogOpen(false), []);
  const closeDrawer = useCallback(() => {
    setActiveEntity(null);
    setNotesTemplate(null);
  }, []);

  const selectEntity = useCallback(({ entity, notesTemplate: template }) => {
    setNotesTemplate(template ?? null);
    setActiveEntity(entity);
    setIsDialogOpen(false);
  }, []);

  return {
    activeEntity,
    closeDialog,
    closeDrawer,
    isDialogOpen,
    notesTemplate,
    openDialog,
    selectEntity
  };
};
